export default "__VITE_ASSET__f8fd7775__"